import { getGetApiV1ThreeLetterCodeClientAdminsClientKey } from '@fukuri-admins/apis/client/gen/endpoints';
import { useToast } from '@fukuri-admins/ui/common/Toast/hooks';
import { mutate } from 'swr';
import { usePostShippingAddressConfirmation } from './usePostShippingAddressConfirmation';

type Args = {
  /** 企業コード */
  threeLetterCode: string;
};

type IUseShippingConfirmationDialog = (args: Args) => {
  state: {
    /** 確定 API 実行中かどうか */
    isMutating: boolean;
  };
  actions: {
    /** 「この内容で確定」ボタン押下時の処理 */
    handleConfirm: () => void;
    /** 「内容を修正」ボタン押下時の処理（TODO: MMT-423 で実装） */
    handleEdit: () => void;
  };
};

/**
 * 送付先住所確認ダイアログの Component Hook
 *
 * - 確定 API の実行
 * - 成功時のトースト表示
 * - エラー時のトースト表示
 * - クライアント情報の再取得（mutate）
 */
export const useShippingConfirmationDialog: IUseShippingConfirmationDialog = ({
  threeLetterCode,
}) => {
  const { showToast } = useToast();

  const { trigger, isMutating } = usePostShippingAddressConfirmation(threeLetterCode, {
    onSuccess: () => {
      showToast({ message: '送付先住所を確認しました', status: 'success' });
      // クライアント情報を再取得して confirmed_at を最新化
      mutate(getGetApiV1ThreeLetterCodeClientAdminsClientKey(threeLetterCode));
    },
    onError: error => {
      // 409（確認済み）等のエラーをトーストで通知
      const errors = error.response?.data?.errors;
      if (errors && errors.length > 0) {
        showToast({ message: errors[0], status: 'danger' });
      } else {
        showToast({ message: '確認処理に失敗しました。', status: 'danger' });
      }
      // エラー時も再取得して最新状態を反映
      mutate(getGetApiV1ThreeLetterCodeClientAdminsClientKey(threeLetterCode));
    },
  });

  const handleConfirm = () => {
    trigger();
  };

  const handleEdit = () => {
    // TODO(MMT-423): 編集ダイアログを開く処理を実装する
    // 現在はハンドラの受け口のみ用意
  };

  return {
    state: {
      isMutating,
    },
    actions: {
      handleConfirm,
      handleEdit,
    },
  };
};
